export default "__VITE_ASSET__DNTZveo7__"